import React from "react";
import * as Scrivito from "scrivito";
import { FirstSubnavItem } from "components/LeftSidebar/SubnavsFirst/FirstSubnavItem";
import type { LeftSidebarAcitveButton } from "interfaces/shared.types";

type LeftSidebarSubnavFirstProps = {
  references: Scrivito.Obj[];
  setActiveButton: React.Dispatch<
    React.SetStateAction<null | LeftSidebarAcitveButton>
  >;
};

export const LeftSidebarSubnavFirst = Scrivito.connect(
  ({ references, setActiveButton }: LeftSidebarSubnavFirstProps) => {
    // In this case Scrivito.currentPageParams doesn't work for some reason so we use URLSearchParams
    const unparseValues = (value: string | null) =>
      value === null || value === "undefined" ? undefined : value;
    const params = new URLSearchParams(window.location.search);
    const projectId = unparseValues(params.get("projectId"));
    const seriesId = unparseValues(params.get("seriesId"));

    return (
      <>
        {references?.map((referenceObj, key) => (
          <FirstSubnavItem
            key={key}
            seriesId={seriesId}
            projectId={projectId}
            referenceObj={referenceObj}
            setActiveButton={setActiveButton}
          />
        ))}
      </>
    );
  },
);
